import AddableFileProviderInfo from '../../utils/AddableFileProviderInfo';
import AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export interface AuthUrlInfo {
    csrfToken: string;
    redirectUrl: string;
    updateProvider?: boolean;
}

export interface AuthWindowInfo {
    info: AuthUrlInfo;
    onProviderAdded: (provider: AttachmentDataProvider) => void;
    onErrorAddingProvider: (error: Error) => void;
    getAddableFileProviderInfo: (
        providerType: AttachmentDataProviderType
    ) => AddableFileProviderInfo;
}

const infoForAuthWindowMap: { [key: number]: AuthWindowInfo } = {};

export function setAuthWindowInfo(
    providerType: AttachmentDataProviderType,
    authInfo: AuthWindowInfo
) {
    infoForAuthWindowMap[providerType] = authInfo;
}

export function getAuthWindowInfo(providerType: AttachmentDataProviderType): AuthWindowInfo {
    if (providerType in infoForAuthWindowMap) {
        return infoForAuthWindowMap[providerType];
    }

    return null;
}

export function clearAuthWindowInfo(providerType: AttachmentDataProviderType) {
    infoForAuthWindowMap[providerType] = null;
}
